import { siteConfig } from '../config/site'
import { legalPages, type LegalPageId } from '../data'
import { NotFoundPage } from './NotFoundPage'

interface LegalPageProps {
  pageId: LegalPageId
}

export function LegalPage({ pageId }: LegalPageProps) {
  const page = legalPages.find(({ id }) => id === pageId)
  if (!page) return <NotFoundPage />

  const canonicalUrl = `${siteConfig.siteUrl}${page.path}`

  return (
    <article className="content-page legal-page">
      <title>{`${page.title} | Pack Print Mail`}</title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteConfig.displayName} />
      <meta property="og:title" content={`${page.title} | Pack Print Mail`} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={canonicalUrl} />

      <header className="legacy-page-title">
        <div className="inner-shell">
          <p>Pack Print Mail LLC</p>
          <h1>{page.title}</h1>
        </div>
      </header>

      <div className="inner-shell content-page__body legal-page__body">
        <p className="legal-page__updated">Effective date: {page.updated}</p>
        {page.sections.map((section) => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.items ? (
              <ul>
                {section.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </article>
  )
}
